<script>
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed, authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import Map from "@/components/Map.vue";
import MultiSelect from "vue-multiselect";
import Middleware from "@/helpers/middlewares";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  page: {
    title: "Register Hotel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Register Hotel",
      registerNewHotel: {
        brand: {
          value: null,
          type: null,
          title: "What brand you have in hotel?",
        },
        address: {
          value: null,
          type: null,
          title: "What is address of hotel?",
        },
        total_rooms: {
          value: null,
          type: "number",
          title: "How many room does hotel have?",
        },
        name: { value: null, type: "text", title: "What is name of hotel ?" },
        city: {
          value: null,
          type: "text",
          title: "City your hotel located in",
        },
        state: {
          value: null,
          type: "text",
          title: "State your hotel located in",
        },
        country: {
          value: null,
          type: "text",
          title: "Country your hotel located in",
        },
        zip_code: {
          value: null,
          type: "text",
          title: "What is zip code of your hotel?",
        },
        email: {
          value: null,
          type: "email",
          title: "What is email of your hotel?",
        },
        front_desk_number: {
          value: null,
          type: null,
          title: "What is frontdesk no of your hotel?",
        },
        website: {
          value: null,
          type: "search",
          title: "What is website of your hotel?",
        },
      },
      previous: "",
      current: "brand",
      next: "address",
      brands: [],
      googleData: null,

      // For validations
      isHaveError: false,
      isHaveRegisterError: false,
      errorMessage: null,
    };
  },
  components: {
    Map,
    MultiSelect,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getBrands();
  },
  methods: {
    ...authMethods,
    // Method is use for get list of brands
    async getBrands() {
      const response = await hotelService.brandList();
      if (response) {
        response.map((item) => {
          const data = {
            text: item.name,
            value: item.id,
            logo: item.logo,
          };
          if (item.name == "Other") {
            this.brands.unshift(data);
            this.registerNewHotel.brand.value = data;
          } else {
            this.brands.push(data);
          }
        });
      }
    },
    async finalRegister() {
      try {
        const registerData = new FormData();
        Object.keys(this.registerNewHotel).map((key) => {
          if (key == "brand") {
            registerData.append(
              "brand",
              this.registerNewHotel[key].value.value
            );
          } else {
            registerData.append(key, this.registerNewHotel[key].value);
          }
        });
        if (this.googleData !== null) {
          registerData.append("latitude", this.googleData.latitude);
          registerData.append("longitude", this.googleData.longitude);
          registerData.append("map_location_url", this.googleData.url);
          registerData.append("g_place_id", this.googleData.place_id);
        }
        registerData.append("rating", this.googleData.rating);
        const response = await hotelService.registerHotel(registerData);
        if (response) {
          Middleware.notification("Successfully registered !!", "success");

          UserService.updateProfile({ user_hotel: response.id }).then(() => {
            let user = JSON.parse(localStorage.getItem("user"));
            user.user.hotel.push(response);
            localStorage.setItem("user", JSON.stringify("user", user));
            this.register(user);
            this.user.user.user_hotel;
            this.setHotel(response.id).then(() => {
              this.$router.push("/dashboard");
              window.location.reload();
            });
          });
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.isHaveRegisterError = true;
          this.errorMessage = error.response.data;
        }
        errorHandler(error);
      }
    },
    // Method is used to handle search result
    async setPlace(place) {
      let shouldRegister = true;
      const allHotels = await hotelService.getAllHotels();
      allHotels.forEach((element) => {
        if (element != null && element.g_place_id && shouldRegister) {
          if (place.place_id == element.g_place_id) {
            shouldRegister = false;
          }
        }
      });
      if (shouldRegister == true) {
        let forDetails = [];
        this.googleData = place;
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        this.googleData = { ...this.googleData, latitude: lat, longitude: lng };
        if (place.formatted_address) {
          this.registerNewHotel.address.value = place.formatted_address;
        }
        for (
          let index = 0;
          index < this.googleData.address_components.length;
          index++
        ) {
          const element = this.googleData.address_components[index];
          forDetails.push(element);
        }

        // To get Location Details like city, state, country etc.
        for (let index = 0; index < forDetails.length; index++) {
          const element = forDetails[index];
          if (element.types[0] == "country") {
            this.registerNewHotel.country.value = element.long_name;
          }
          if (element.types[0] == "administrative_area_level_1") {
            this.registerNewHotel.state.value = element.short_name;
          }
          if (element.types[0] == "administrative_area_level_2") {
            this.registerNewHotel.city.value = element.long_name;
          } else if (element.types[0] == "administrative_area_level_3") {
            this.registerNewHotel.city.value = element.long_name;
          }
          if (element.types[0] == "locality") {
            this.registerNewHotel.address.value = element.long_name;
          }
          if (element.types[0] == "postal_code") {
            this.registerNewHotel.zip_code.value = element.long_name;
          }
        }

        this.registerNewHotel.front_desk_number.value = this.googleData
          .international_phone_number
          ? this.googleData.international_phone_number
          : null;
        this.registerNewHotel.name.value = this.googleData.name
          ? this.googleData.name
          : "";
        this.registerNewHotel.website.value = this.googleData.website
          ? this.googleData.website
          : "";
      } else {
        Middleware.notification("This hotel already exists !!", "danger");
        setTimeout(() => {
          this.$router.go();
        }, 1000);
      }
    },
    // Method is use for handle change values
    changeVal({ value, next, previous }) {
      if (value == null || value == "") {
        this.isHaveError = true;
      } else {
        this.isHaveError = false;
        Object.keys(this.registerNewHotel).map((key, index) => {
          if (key == next) {
            this.previous = this.current;
            this.current = next;
            this.next = Object.keys(this.registerNewHotel)[index + 1];
          }
        });
        if (this.current == "website" && previous == "front_desk_number") {
          this.finalRegister();
        }
      }
    },
    // Method is used for make template option label dynamic
    customLabel({ title }) {
      return `${title}`;
    },
    // Method is use for go back to previous position
    goBack() {
      this.isHaveRegisterError = false;
      this.next = this.current;
      this.current = this.previous;
      Object.keys(this.registerNewHotel).map((key, index) => {
        if (key == this.current) {
          this.previous =
            Object.keys(this.registerNewHotel)[index - 1] !== undefined
              ? Object.keys(this.registerNewHotel)[index - 1]
              : "";
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <b-card class="hotel-card-height">
      <h4>{{ title }}</h4>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-8">
                <template v-for="(item, index) in registerNewHotel">
                  <div
                    :key="index"
                    class="text-start my-5"
                    v-if="current == index"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <h4 class="fw-bold mb-4">
                      {{ item.title }}
                    </h4>
                    <div class="d-flex align-items-center">
                      <div
                        v-if="current == 'brand'"
                        class="brand-select w-50 me-3"
                      >
                        <MultiSelect
                          v-model="registerNewHotel.brand.value"
                          placeholder="Select Template"
                          label="text"
                          track-by="value"
                          :options="brands"
                          :show-labels="false"
                          :allow-empty="false"
                          class="multi-select-template"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <div class="d-flex align-items-center">
                              <div class="single-select-dropdown">
                                <img
                                  class="logo-brand"
                                  :src="props.option.logo"
                                />
                              </div>
                              <span class="option-title ms-2">{{
                                props.option.text
                              }}</span>
                            </div>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div class="d-flex align-items-center">
                              <div class="single-select-dropdown">
                                <img
                                  class="logo-brand"
                                  :src="props.option.logo"
                                />
                              </div>
                              <span class="option-title ms-2">{{
                                props.option.text
                              }}</span>
                            </div>
                          </template>
                        </MultiSelect>
                      </div>

                      <div
                        class="position-relative d-flex w-100"
                        v-else-if="current == 'address'"
                      >
                        <Map
                          class="me-3 w-100 wizard-form-input"
                          @update:place="setPlace"
                        ></Map>
                      </div>

                      <vue-tel-input
                        v-else-if="current == 'front_desk_number'"
                        v-model="item.value"
                        class="wizard-form-input form-control me-3 w-50"
                        autocapitalize="off"
                        id="tel-input"
                        :preferred-countries="['us', 'gb', 'ua']"
                        mode="international"
                        required
                        :validCharactersOnly="true"
                      />

                      <input
                        v-else
                        v-model.trim="item.value"
                        :type="item.type"
                        class="form-control wizard-form-input w-50 me-3"
                      />

                      <button
                        type="button"
                        class="btn bg-primary submit-btn"
                        @click="
                          changeVal({
                            value: registerNewHotel[index].value,
                            next: next,
                            previous: previous,
                          })
                        "
                      >
                        <i
                          class="fas fa-check text-light"
                          v-if="
                            (current == 'website' &&
                              previous == 'front_desk_number') == false
                          "
                        />
                        <span class="text-light" v-else>Done</span>
                      </button>
                    </div>

                    <div v-if="isHaveError" class="text-danger f-14">
                      <span class="text-capitalize"
                        >{{ current.replace("_", " ") }} is required.</span
                      >
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-md-12 mt-5">
                <div v-for="(item, index) in registerNewHotel" :key="index">
                  <div
                    class="d-flex align-items-start mb-2"
                    v-if="item.value != null"
                  >
                    <h5 class="text-capitalize w-md">
                      {{
                        index == "front_desk_number"
                          ? "Frontdesk No."
                          : index.replaceAll("_", " ")
                      }}
                    </h5>
                    <span class="mx-2">:</span>
                    <h5 class="text-truncate fw-light">
                      {{
                        index !== "brand"
                          ? registerNewHotel[index].value
                          : registerNewHotel[index].value !== null
                          ? registerNewHotel[index].value.text
                          : ""
                      }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="previous !== ''"
        class="wrapper bg-primary text-light"
        @click="goBack()"
      >
        <i class="bx bx-chevron-left"></i>
      </div>
      <div class="mt-2" v-if="isHaveRegisterError">
        <ul>
          <li
            class="alert alert-danger w-25 text-truncate"
            role="alert"
            v-for="(error, index) in errorMessage"
            :key="index"
          >
            {{ index }}: {{ error[0] }}
          </li>
        </ul>
      </div>
    </b-card>
  </div>
</template>

<style>
.wrapper {
  cursor: pointer;
  width: 50px;
  height: 50px;
  font-size: 34px;
  position: fixed;
  bottom: 46px;
  right: 30px;
  border-radius: 100%;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}
.brand-select .multiselect__input::placeholder {
  font-size: 18px;
}
.brand-select .multiselect__tags {
  display: flex;
  align-items: center;
  min-height: 50px !important;
}

.brand-select .multiselect__element .option-title {
  font-size: 18px;
}
.brand-select .single-select-dropdown {
  min-width: 38px;
}
.brand-select .multiselect__option {
  display: flex;
  align-items: center;
  min-height: 58px;
}
.brand-select .multiselect__single span {
  font-size: 18px;
}
.logo-brand {
  max-width: 34px;
  max-height: 34px;
}
.submit-btn {
  min-width: 80px;
  font-size: 22px;
}
.hotel-card-height {
  min-height: calc(100vh - 100px);
}
.brand-select .multiselect__option--highlight,
.multiselect__option--highlight:after {
  background-color: #50a5f12e !important;
  color: #495057 !important;
}
</style>
